import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/circle-dashed.vue
var o = {
	name: "DtIconCircleDashed",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--circle-dashed"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Circle Dashed",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		d: "M6.855 10.418a.5.5 0 0 1 .19.982 5.5 5.5 0 0 1-2.09 0 .5.5 0 0 1 .19-.982c.564.11 1.145.109 1.71 0Zm2.87-1.894a.5.5 0 0 1 .829.56 5.5 5.5 0 0 1-1.486 1.48.5.5 0 1 1-.557-.83 4.5 4.5 0 0 0 1.215-1.21Zm-8.154-.15a.5.5 0 0 1 .695.137 4.5 4.5 0 0 0 1.21 1.214.5.5 0 0 1-.561.829 5.5 5.5 0 0 1-1.48-1.486.5.5 0 0 1 .136-.693ZM1.187 4.56a.5.5 0 0 1 .395.586 4.502 4.502 0 0 0 0 1.71.5.5 0 0 1-.981.19 5.5 5.5 0 0 1 0-2.09.5.5 0 0 1 .586-.396Zm9.628 0a.5.5 0 0 1 .585.396 5.5 5.5 0 0 1 0 2.09.5.5 0 0 1-.982-.19c.11-.564.11-1.145 0-1.71a.5.5 0 0 1 .397-.586ZM8.39 1.58a.5.5 0 0 1 .694-.133c.584.396 1.086.9 1.48 1.485a.5.5 0 1 1-.83.558 4.5 4.5 0 0 0-1.21-1.215.5.5 0 0 1-.134-.694Zm-5.46-.144a.5.5 0 0 1 .558.83 4.5 4.5 0 0 0-1.215 1.21.5.5 0 0 1-.828-.56c.396-.584.9-1.086 1.486-1.48ZM4.956.6a5.5 5.5 0 0 1 2.09 0 .5.5 0 0 1-.19.982 4.501 4.501 0 0 0-1.71 0A.5.5 0 1 1 4.955.6Z"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=circle-dashed.js.map